import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { Button } from 'components/ui/button';

export function DealFormCancelButton({ className, deal, onCancel }) {
  return (
    <Button className={className} disabled={deal.saving} label="Cancel" variant="ghost" onClick={onCancel} />
  );
}

DealFormCancelButton.propTypes = {
  className: PropTypes.string,
  deal: PropTypes.shape({
    saving: PropTypes.bool,
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

export default connect(mapStateToProps)(DealFormCancelButton);
